define('home/models/HomepageProfile',[
    'jquery',
    'underscore',
    'backbone',

    'core/UniqueModel',
    'core/strings',
    'core/config',

    'home/models/Session',
    'home/models/Feed',
    'home/models/ChannelProfile',
    'home/models/ChannelProfileFeed',
    'home/models/FollowRecommendationFeed',
    'home/models/ActivityFeed',
    'home/collections/FeedItemCollection',
], function (
    $,
    _,
    Backbone,

    UniqueModel,
    strings,
    coreConfig,

    Session,
    Feed,
    ChannelProfile,
    ChannelProfileFeed,
    FollowRecommendationFeed,
    ActivityFeed,
    FeedItemCollection
) {
    'use strict';

    var gettext = strings.get;

    var HomepageProfile = Backbone.Model.extend({
        initialize: function () {
            var fetchOptions = {
                routingVersion: coreConfig.feedApiVersion,
            };

            this.popular = new ActivityFeed({
                fetchOptions: fetchOptions,
            }, {
                collectionOptions: {
                    type: 'home',
                },
            });

            this.comments = new Feed({
                fetchOptions: fetchOptions,
            }, {
                collectionClass: FeedItemCollection,
                collectionOptions: {
                    type: 'comments',
                },
            });

            this.discussions = new ActivityFeed({
                fetchOptions: fetchOptions,
            }, {
                collectionOptions: {
                    type: 'discussions',
                },
            });

            this.interestingChannels = new UniqueModel(ChannelProfileFeed, {
                listName: ChannelProfileFeed.LIST_NAMES.promoted,
            });

            this.interestingUsers = FollowRecommendationFeed.createUserFollowRecommendationFeed();

            // Spotlight top feed is shown if popular feed is empty. It will only be fetched if necessary.
            this.spotlightProfile = new UniqueModel(ChannelProfile, {
                id: this.constructor.SPOTLIGHT_ID, // must have id for UniqueModel
                channel: this.constructor.SPOTLIGHT_ID,
            }, {
                topActivitiesOptions: {
                    fetchOptions: {
                        limit: 3,
                    },
                },
            });
        },

        ensureFetchedSpotlightProfile: function () {
            this.spotlightProfile.ensureFetchedTopActivities();
        },

        ensureFetched: function () {
            if (Session.isKnownToBeLoggedOut()) {
                // If user is logged out, don't kick off fetch for his/her popular feed/comments/discussions.
                // Also mark the feeds as already fetched so that calling ensureFetched
                // later won't try to kick off any fetches that we know will fail.
                this.comments.set({ fetched: true });

                // Also need to set comments.fetchPromise for this.commentsPromise below, used by the view.
                this.comments.fetchPromise = $.Deferred().resolve().promise();

                this.popular.set({ fetched: true });
                this.discussions.set({ fetched: true });

                // Spotlight top feed is shown to logged out users
                this.ensureFetchedSpotlightProfile();
            } else {
                // Spotlight top feed is shown if popular feed is empty. Only
                // fetch it after it is known to be necessary.
                this.popular.ensureFetched().always(_.bind(function () {
                    if (!this.popular.items.length)
                        this.ensureFetchedSpotlightProfile();
                }, this));

                this.comments.ensureFetched();
                this.discussions.ensureFetched();
            }
            this.commentsPromise = this.comments.fetchPromise;

            this.interestingUsers.ensureFetched();

            this.interestingChannels.ensureFetched();
        },

        initializeAndFetchInterestingForums: function () {
            if (!this.interestingForums)
                this.interestingForums = FollowRecommendationFeed.createForumFollowRecommendationFeed();

            this.interestingForums.ensureFetched();
        },
    }, {
        SPOTLIGHT_ID: 'spotlight',
        MAX_SPOTLIGHT_ITEMS: {
            // NUM is used to show/fetch the correct number of spotlight items, TEXT is used in templates.
            // They must be the same number.
            NUM: 3,
            TEXT: gettext('3'),
        },
    });

    UniqueModel.addType('HomepageProfile', HomepageProfile);

    return HomepageProfile;
});

